import { DesktopModal } from '@byecode/ui'
import { useStore } from '@xyflow/react'

import { useFlowContainerContext } from '@/contexts/FlowContext'

import { NodeConfigure } from '../../components/NodeConfigure'

export const NodeConfigureModal = () => {
    const rootEl = useStore(s => s.domNode)
    const { modalState } = useFlowContainerContext()
    const nodeId = modalState?.selectedNodeId
    return (
        <DesktopModal
            open
            withOverlay={false}
            closeOnClickOverlay={false}
            trapFocus={false}
            width={360}
            target={rootEl}
            withCloseIcon={false}
            styles={{
                root: { pointerEvents: 'none' },
                modal: {
                    pointerEvents: 'initial',
                    position: 'absolute',
                    top: 60,
                    right: 12,
                    bottom: 12
                },
                header: {
                    display: 'none'
                },
                title: {
                    lineHeight: 'unset'
                },
                actions: {
                    alignSelf: 'flex-start'
                },
                body: {
                    padding: '0 !important'
                }
            }}
            transition={{ from: { x: '100%' }, to: { x: '0%' } }}
        >
            <NodeConfigure key={nodeId} nodeId={nodeId} />
        </DesktopModal>
    )
}
